module.exports = __webpack_public_path__ + "img/starting.5f4cd439.png";